import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports"
export default class extends Controller {
  connect() {
    if (!document.querySelector('body[data-namespace*="reports/"]')) return;

    this.setupModalLoader()
    this.setupReportletSuggestions()
    this.setupSuggestionClick()
    this.setupRemoteLinks()
    this.setupEditableTitles(".question-title", "reporting_items", "reporting-item-id")
    this.setupEditableTitles(".report-title", "reports", "report-id")
  }

  setupModalLoader() {
    const modal = document.getElementById("report_modal")
    if (!modal) return

    modal.addEventListener("show.bs.modal", (e) => {
      const modalBody = modal.querySelector(".modal-body")
      if (modalBody && e.relatedTarget?.href) {
        fetch(e.relatedTarget.href)
          .then(res => res.text())
          .then(html => modalBody.innerHTML = html)
      }
    })
  }

  setupReportletSuggestions() {
    const input = document.getElementById("reportlet_path")
    if (!input) return

    input.addEventListener("keyup", () => {
      const notice = document.getElementById("reportlet_notice")
      if (notice) notice.style.display = "none"

      const url = `/reportlets/suggest?path=${input.value}&support_area=${input.dataset.supportArea}`
      fetch(url)
        .then(res => res.json())
        .then(data => {
          const span = document.querySelector("#reportlet_notice span")
          if (span) {
            span.innerHTML = data.join(", ")
            if (data.length > 0 && notice) {
              notice.style.display = "block"
            }
          }
        })
    })
  }

  setupSuggestionClick() {
    document.addEventListener("click", (e) => {
      if (e.target.closest("#reportlet_notice a")) {
        e.preventDefault()
        const span = document.querySelector("#reportlet_notice span")
        const input = document.getElementById("reportlet_path")
        if (span && input) input.value = span.textContent
      }
    })
  }

  setupRemoteLinks() {
    document.addEventListener("click", (e) => {
      const target = e.target.closest(".remote-combine, .remote-swap, .remote-hide, .remote-show")
      if (target) {
        const loader = document.getElementById("loader")
        if (loader) loader.style.display = "block"
      }
    })
  }

  setupEditableTitles(selector, endpoint, dataAttribute) {
    document.addEventListener("keypress", (e) => {
      const el = e.target.closest(selector)
      if (!el || e.which !== 13) return

      const id = el.dataset[dataAttribute]
      const title = el.textContent
      const loader = document.getElementById("loader")
      if (loader) loader.style.display = "block"

      fetch(`/${endpoint}/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ [endpoint.slice(0, -1)]: { title } })
      })

      e.preventDefault()
    })

    document.addEventListener("blur", (e) => {
      const el = e.target.closest(selector)
      if (!el) return
      el.textContent = el.dataset.originalTitle
    }, true)
  }
}
